<section class="hero">
  <video autoplay muted loop playsinline id="hero-video" preload="metadata">
    <source
      src="https://res.cloudinary.com/djqsg8e9k/video/upload/v1690318831/wave_eu7sxt.mp4#t=0.5"
      type="video/mp4"
    />
  </video>
  <div class="overlay">
    <h1 data-aos="fade-in" data-aos-delay="500">
      Sail into the future of marine
    </h1>
    <div class="content">
      <h2 data-aos="fade-in" data-aos-delay="600">
        Discover the depths of convenience and dive into our cutting-edge
        digital marine solutions.
      </h2>
      <a
        data-aos="fade-in"
        data-aos-delay="700"
        class="landing-v2-button"
        href="/new-home#solutions"
      >
        <span class="icon">
          <svg
            width="26"
            height="27"
            viewBox="0 0 26 27"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.927659"
              y1="25.8056"
              x2="25.0061"
              y2="1.72716"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="6.25293"
              y1="1.43408"
              x2="25.7132"
              y2="1.43408"
              stroke="currentColor"
              stroke-width="2"
            />
            <line
              x1="24.7129"
              y1="22.0596"
              x2="24.7129"
              y2="2.43399"
              stroke="currentColor"
              stroke-width="2"
            />
          </svg>
        </span>
        <span> see our solutions </span>
      </a>
    </div>
  </div>
</section>
